import axiosInstance from "./axiosInstance";

export function create(param) {
  return axiosInstance.post('culture/add',param)
}

export function update(param) {
  return axiosInstance.post('culture/edit',param)
}

export function del(param) {
	return axiosInstance.post('culture/del', param)
}

export function query(param) {
  return axiosInstance.post('culture/query',param)
}

export function queryNext(param) {
  return axiosInstance.post('culture/queryNext',param)
}

export function upload(formData) {
	return axiosInstance.post('file/obsUploadFile', formData)
}

export function queryCulture(param) {
  return axiosInstance.post('culture/query',param)
}